import { gql } from 'graphql-request'

export const GET_GAMES_BOXES_ROOMS_DETAILS = gql`
  query GET_GAMES_BOXES_ROOMS_DETAILS(
    $take: Int
    $skip: Int
    $gameBoxRoomId: Int
    $userId: Int
    $valueEarning: Int
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGamesBoxesRoomsDetails(
      take: $take
      skip: $skip
      gameBoxRoomId: $gameBoxRoomId
      userId: $userId
      valueEarning: $valueEarning
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        gameBoxRoomId
        userId
        user {
          id
          username
          imgUser
        }
        createdAt
        updatedAt
        valueEarning
      }
    }
  }
`

export const GET_GAME_BOX_ROOM_DETAIL_COUNT = gql`
  query GET_GAME_BOX_ROOM_DETAIL_COUNT($gameBoxRoomId: Int) {
    getGameBoxRoomDetailCount(gameBoxRoomId: $gameBoxRoomId) {
      error
      status
      data {
        count
      }
    }
  }
`
